import { TranslocoOptions } from '@jsverse/transloco';
import { isDevMode } from '@angular/core';
import { TranslocoHttpLoader } from '../../transloco-loader';

export const langConfig: TranslocoOptions = {
  config: {
    availableLangs: [
      { id: 'en', label: 'English' },
      { id: 'da', label: 'Danish' },
    ],
    defaultLang: 'en',
    fallbackLang: 'en',
    // Remove this option if your application doesn't support changing language in runtime.
    reRenderOnLangChange: true,
    prodMode: !isDevMode(),
  },
  loader: TranslocoHttpLoader,
};
